import React, { useState, useEffect, useRef } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { usePackageStore } from 'stores/packageStore'
import FlagsSidebar from './FlagsSidebar'

export default function FlagsSidebarWrapper({ packageId, role }) {
  const requirements = usePackageStore(
    useShallow((s) => s.package?.visible_package_requirements ?? [])
  )
  const [flagsSidebarOpen, setFlagsSidebarOpen] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const el = containerRef.current?.closest('.req-sidebar')
    if (!el) return

    function sync() {
      const rect = el.getBoundingClientRect()
      document.documentElement.style.setProperty('--flags-sidebar-width', `${window.innerWidth - rect.left - 30}px`)
      document.documentElement.style.setProperty('--flags-sidebar-right', '0px')
    }

    sync()
    const observer = new ResizeObserver(sync)
    observer.observe(el)
    window.addEventListener('resize', sync)
    return () => {
      observer.disconnect()
      window.removeEventListener('resize', sync)
    }
  }, [])

  useEffect(() => {
    function handleOpen(e) {
      if (e.detail?.packageId === packageId) setFlagsSidebarOpen(true)
    }
    window.addEventListener('open-flags-sidebar', handleOpen)
    return () => window.removeEventListener('open-flags-sidebar', handleOpen)
  }, [packageId])

  return (
    <div ref={containerRef}>
      <FlagsSidebar
        role={role}
        requirements={requirements}
        isOpen={flagsSidebarOpen}
        onClose={() => setFlagsSidebarOpen(false)}
      />
    </div>
  )
}
